import {getRedirectTo, isRedirectTo} from "../other/redirect_to.js";
import {getSelectedPlan, getSelectedPlanURL, isSelectedPlan} from "../other/selected_plan.js";
import showErrors from "../errors/showErrors.js";
import checkCaptcha from "../other/check_captcha.js";

export default async function() {
    try {
        this.loading = true;

        let form_data = new FormData;
        form_data.append('re_token', await checkCaptcha());
        form_data.append('action', ajax_var.action_gs_login);
        form_data.append('nonce', ajax_var.nonce);
        form_data.append('email', this.userData[this.current]['email']);
        form_data.append('password', this.userData[this.current]['password']);

        const response = await axios.post(ajax_var.url, form_data);
        const responseData = response.data?.data;
        const isActiveSubscription = responseData?.user_options?.activeSubscription

        if (isRedirectTo()) {
            window.location.href = getRedirectTo();
            return;
        }
        if (isSelectedPlan()) {
            if (isActiveSubscription) {
                window.location.href = getSelectedPlanURL()
            } else {
                window.location.href = ajax_var.baseurl + "?goToCheckout=1&selectedPlan=" + getSelectedPlan();
            }
            return;
        }

        if (isActiveSubscription) {
            window.location.href = ajax_var.account_page_url;
            return;
        }

        if (responseData?.user_options?.isUserRoleSupplier) {
            window.location.href = ajax_var.gs_shop_suppliers_subscriptions_url;
        } else {
            window.location.href = ajax_var.gs_shop_subscriptions_url;
        }

    } catch (error) {
        showErrors.bind(this)('login', error);
        this.loading = false;
    }
};
